module.exports = __webpack_public_path__ + "img/introduce.c1bf0f4b.png";